import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=19afb7f1"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports